import { render, staticRenderFns } from "./DefaultMode.vue?vue&type=template&id=3d0b1447&scoped=true&"
import script from "./DefaultMode.vue?vue&type=script&lang=ts&"
export * from "./DefaultMode.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultMode.vue?vue&type=style&index=0&id=3d0b1447&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b1447",
  null
  
)

export default component.exports